import { render, staticRenderFns } from "./EventIntro.vue?vue&type=template&id=4d73b896&scoped=true"
import script from "./EventIntro.vue?vue&type=script&lang=js"
export * from "./EventIntro.vue?vue&type=script&lang=js"
import style0 from "./EventIntro.vue?vue&type=style&index=0&id=4d73b896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d73b896",
  null
  
)

export default component.exports